// * GET =====================================
export const ALERT_NOTIFICATION_GET = (eventId: number) =>
  `/alert_notification/${eventId}`;

// * PATCH ===================================
export const ALERT_NOTIFICATION_PATCH_READ = (eventId: number) =>
  `/alert_notification/${eventId}/read`;

// * POST ====================================

// * DELETE ==================================

// * PUT =====================================
